import axios from 'axios';

import { ApiResponse } from '../../models/api.response.model';
import { Error } from '../../models/error.model';
import { CompanyServices } from '../../models/company.services.model';
import { Service } from '../../models/service.model';
import { Message } from '../../models/message.model';
import { Company } from '../../models/company.model';
import { authToken } from '../../scripts/authentication.script';

export class ServiceDA {
  static apiResponse: ApiResponse

  public static async getServices(
    id_company: string,
    service_name: string,
    category_id: string,
    sort_field: string,
    sort_mode: string,
    page: number = 1,
    limit: number = 20
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let companyServices: CompanyServices | null = null
      let error: Error | null = null

      await axios.get('../../../../../database/services.data.json').then(response => { companyServices = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { error = response.data }).catch(error => { alert(error) })

      if (companyServices!.id_company === id_company) {
        companyServices!.filter = { name: service_name , category: category_id, sort_mode: sort_mode, sort_field: sort_field }

        this.apiResponse = {
          status: 200,
          message: 'Success',
          data: companyServices
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: error
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/services?name=${service_name}&category=${category_id}&sort_field=${sort_field}&sort_mode=${sort_mode}&page=${page}&limit=${limit}`

      let config: any = {
        headers: { Authorization: authToken() }
      }

      await axios.get(url, config).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data?.data ?? response.data
        }
      }).catch(error => {
        this.apiResponse = {
          status: error.response?.status ?? 500,
          message: error.response?.statusText ?? 'Unknown error',
          data: error.response?.data?.error ?? error.message
        }
      })
    }

    return this.apiResponse
  }

  public static async getService(
    id_company: string,
    id_service: string
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let service: Service | null = null
      let error: Error | null = null

      await axios.get('../../../../../database/service.data.json').then(response => { service = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { error = response.data }).catch(error => { alert(error) })

      if (service!.id === id_service) {
        this.apiResponse = {
          status: 200,
          message: 'Success',
          data: service
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: error
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/services/${id_service}`

      let config: any = {
        headers: { Authorization: authToken() }
      }

      await axios.get(url, config).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data?.data ?? response.data
        }
      }).catch(error => {
        this.apiResponse = {
          status: error.response?.status ?? 500,
          message: error.response?.statusText ?? 'Unknown error',
          data: error.response?.data?.error ?? error.message
        }
      })
    }

    return this.apiResponse
  }

  public static async postService(
    id_company: string,
    display_name: string,
    description: string,
    code: string,
    sku: string,
    codebar: string,
    price_sale: string,
    price_purchase: string,
    tax_code_sale: string,
    tax_code_purchase: string,
    tax_rate_sale: number,
    tax_rate_purchase: number,
    unit_id: string | { id: string, type: string, name: string, symbol: string },
    category_id: string,
    discount: { type: string, value: string, quantity: string },
    names: { en: string, fr: string, it: string, de: string },
    accounts: { expense: string, vat: string, income: string },
    features: { id_feature: string, name: string, value: string }[],
    tags: string[],
    photos: any[]
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let company: Company | null = null
      let message: Message | null = null
      let error: Error | null = null

      await axios.get('../../../../../database/company.data.json').then(response => { company = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/message.data.json').then(response => { message = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { error = response.data }).catch(error => { alert(error) })

      if (company!.id === id_company) {
        this.apiResponse = {
          status: 201,
          message: 'Success',
          data: message
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: error
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/services`

      let config: any = {
        headers: { Authorization: authToken() }
      }

      let data: any = new FormData()
      data.append('display_name', display_name)
      data.append('description', description)
      data.append('code', code)
      data.append('sku', sku)
      data.append('codebar', codebar)
      data.append('price_sale', price_sale)
      data.append('price_purchase', price_purchase)
      data.append('tax_code_sale', tax_code_sale)
      data.append('tax_code_purchase', tax_code_purchase)
      data.append('tax_rate_sale', tax_rate_sale)
      data.append('tax_rate_purchase', tax_rate_purchase)
      data.append('unit', typeof unit_id === 'object' ? JSON.stringify(unit_id) : unit_id)
      data.append('category', category_id)
      data.append('discount[type]', discount.type)
      data.append('discount[value]', discount.value)
      data.append('discount[quantity]', discount.quantity)
      data.append('names[en]', names.en)
      data.append('names[fr]', names.fr)
      data.append('names[de]', names.de)
      data.append('names[it]', names.it)
      data.append('accounts[expense]', accounts.expense)
      data.append('accounts[vat]', accounts.vat)
      data.append('accounts[income]', accounts.income)

      features.forEach(feature => {
        data.append('features', JSON.stringify(feature))
      })

      tags.forEach(tag => {
        data.append('tags', JSON.stringify(tag))
      })

      photos.forEach((image, index) => {
        if (image instanceof File) {
          data.append(`photos`, image, `${display_name}`)
        } else {
          data.append(`photos_url[${display_name}][${index}]`, image)
        }
      })

      await axios.post(url, data, config).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data?.data ?? response.data
        }
      }).catch(error => {
        this.apiResponse = {
          status: error.response?.status ?? 500,
          message: error.response?.statusText ?? 'Unknown error',
          data: error.response?.data?.error ?? error.message
        }
      })
    }

    return this.apiResponse
  }

  public static async putService(
    id_company: string,
    id_service: string,
    display_name: string,
    description: string,
    code: string,
    sku: string,
    codebar: string,
    price_sale: string,
    price_purchase: string,
    tax_code_sale: string,
    tax_code_purchase: string,
    tax_rate_sale: number,
    tax_rate_purchase: number,
    unit_id: string | { id: string, type: string, name: string, symbol: string },
    category_id: string,
    discount: { type: string, value: string, quantity: string },
    names: { en: string, fr: string, it: string, de: string },
    accounts: { expense: string, vat: string, income: string },
    features: { id_feature: string, name: string, value: string }[],
    tags: string[],
    photos: any[]
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let service: Service | null = null
      let message: Message | null = null
      let error: Error | null = null

      await axios.get('../../../../../database/service.data.json').then(response => { service = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/message.data.json').then(response => { message = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { error = response.data }).catch(error => { alert(error) })

      if (service!.id === id_service) {
        this.apiResponse = {
          status: 200,
          message: 'Success',
          data: message
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: error
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/services/${id_service}`

      let config: any = {
        headers: { Authorization: authToken() }
      }

      let data: any = new FormData()
      data.append('display_name', display_name)
      data.append('description', description)
      data.append('code', code)
      data.append('sku', sku)
      data.append('codebar', codebar)
      data.append('price_sale', price_sale)
      data.append('price_purchase', price_purchase)
      data.append('tax_code_sale', tax_code_sale)
      data.append('tax_code_purchase', tax_code_purchase)
      data.append('tax_rate_sale', tax_rate_sale)
      data.append('tax_rate_purchase', tax_rate_purchase)
      data.append('unit', typeof unit_id === 'object' ? JSON.stringify(unit_id) : unit_id)
      data.append('category', category_id)
      data.append('discount[type]', discount.type)
      data.append('discount[value]', discount.value)
      data.append('discount[quantity]', discount.quantity)
      data.append('names[en]', names.en)
      data.append('names[fr]', names.fr)
      data.append('names[de]', names.de)
      data.append('names[it]', names.it)
      data.append('accounts[expense]', accounts.expense)
      data.append('accounts[vat]', accounts.vat)
      data.append('accounts[income]', accounts.income)

      features.forEach(feature => {
        data.append('features', JSON.stringify(feature))
      })

      tags.forEach(tag => {
        data.append('tags', JSON.stringify(tag))
      })

      photos.forEach((image, index) => {
        if (image instanceof File) {
          data.append(`photos`, image, `${display_name}`)
        } else {
          data.append(`photos_url[${display_name}][${index}]`, image)
        }
      })

      await axios.put(url, data, config).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data?.data ?? response.data
        }
      }).catch(error => {
        this.apiResponse = {
          status: error.response?.status ?? 500,
          message: error.response?.statusText ?? 'Unknown error',
          data: error.response?.data?.error ?? error.message
        }
      })
    }
    return this.apiResponse
  }

  public static async deleteServices(
    id_company: string,
    id_services: string[]
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let services: Service[] | null = null
      let message: Message | null = null
      let error: Error | null = null

      await axios.get('../../../../../database/services.data.json').then(response => { services = response.data.services }).catch(error => { alert(error) })
      await axios.get('../../../../../database/message.data.json').then(response => { message = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { error = response.data }).catch(error => { alert(error) })

      if (services!.some(item => id_services.includes(item.id))) {
        this.apiResponse = {
          status: 200,
          message: 'Success',
          data: message
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: error
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/services`

      let config: any = {
        headers: { Authorization: authToken() },
        data: { services: id_services }
      }

      await axios.delete(url, config).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data?.data ?? response.data
        }
      }).catch(error => {
        this.apiResponse = {
          status: error.response?.status ?? 500,
          message: error.response?.statusText ?? 'Unknown error',
          data: error.response?.data?.error ?? error.message
        }
      })
    }

    return this.apiResponse
  }
}
